import { render, staticRenderFns } from "./BlockTabs.vue?vue&type=template&id=0659c488&scoped=true&"
import script from "./BlockTabs.vue?vue&type=script&lang=js&"
export * from "./BlockTabs.vue?vue&type=script&lang=js&"
import style0 from "./BlockTabs.vue?vue&type=style&index=0&id=0659c488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0659c488",
  null
  
)

export default component.exports